import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '../../api/api';
import { UserMyRadiant } from '../..';
import { Events } from 'ionic-angular';


@Injectable()
export class NotificationProvider {

    jmlNotifikasi = 0;
  
    constructor(public api: Api,public userMyRadiant : UserMyRadiant,private events : Events,
        // public nav : Nav
        ) { }

    deleteAll(params?:any){
        let seq = this.api.get('index.php/myradiant/Aproval/family', params);
        return seq;
    }

    deleteNotification(params?:any){
        let seq = this.api.post('index.php/myradiant/Notification/deleteNotifikasi', params);
        return seq;
    }

    readNotification(params?:any){
        let seq = this.api.post('index.php/myradiant/Notification/readNotification',params);
        return seq;
    }

    countNotification(params?:any){
        let seq = this.api.get('index.php/myradiant/Notification/countNotification',params);
        return seq;
    }

    refreshNotification(){
        let params_notif = {
            employee_id : this.userMyRadiant.data.Employee_ID,
            user_id : this.userMyRadiant.data.id, 
        }
        this.countNotification(params_notif).subscribe((resp) => {
        if (resp['success']) {
            this.events.publish('notification:update',{jml_notifikasi:resp['data']['jml']});
        }
        });
    }

    getNotifUser(params?:any){
        let seq = this.api.get('index.php/myradiant/Notification/getNotification',params);
        return seq;
    }
}



// WEBPACK FOOTER //
// ./src/providers/myradiant/notification/provider.ts